import styled from 'styled-components'

const StyledLoginPanel = styled.div`
  display: flex;
  margin-top: 10vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export default StyledLoginPanel
